module.exports = __webpack_public_path__ + "img/image_browserresize.7bcbdc76.png";